import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Ellipse preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const ellipse: IPresetGeometry = {
	// ahLst: [],
	// avList: [],
	gdLst: [
		// { name: "idx", fmla: { operation: "cos", operands: ["wd2", 2700000] } },
		// instead of microsoft version of angle metric, use degrees
		{ name: "idx", fmla: { operation: FP.Cosine, operands: ["wd2", 45] } },
		// { name: "idy", fmla: { operation: "sin", operands: ["hd2", 2700000] } },
		// instead of microsoft version of angle metric, use degrees
		{ name: "idy", fmla: { operation: FP.Sine, operands: ["hd2", 45] } },
		// this is deviation from microsoft standards, adding padding: 10px 2px for
		// the text rect inside the ellipse
		{ name: "il", fmla: { operation: FP.AddSubtract, operands: ["hc", 10, "idx"] } },
		{ name: "ir", fmla: { operation: FP.AddSubtract, operands: ["hc", "idx", 10] } },
		{ name: "it", fmla: { operation: FP.AddSubtract, operands: ["vc", 2, "idy"] } },
		{ name: "ib", fmla: { operation: FP.AddSubtract, operands: ["vc", "idy", 2] } },
	],

	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "vc" }, type: PathOperationTypes.MOVE_TO },
			{ wR: "wd2", hR: "hd2", stAng: "cd2", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ wR: "wd2", hR: "hd2", stAng: "3cd4", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ wR: "wd2", hR: "hd2", stAng: "0", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ wR: "wd2", hR: "hd2", stAng: "cd4", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.ellipse,
	rect: { l: "il", t: "it", r: "ir", b: "ib" },
	type: GeometryTypes.PRESET,
};

/**
 *  Microsoft open xml preset definition (for Reference purpose only)
 *   <ellipse>
 *   <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <gd name="idx" fmla="cos wd2 2700000" />
 *     <gd name="idy" fmla="sin hd2 2700000" />
 *     <gd name="il" fmla="+- hc 0 idx" />
 *     <gd name="ir" fmla="+- hc idx 0" />
 *     <gd name="it" fmla="+- vc 0 idy" />
 *     <gd name="ib" fmla="+- vc idy 0" />
 *   </gdLst>
 *   <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <cxn ang="3cd4">
 *       <pos x="hc" y="t" />
 *     </cxn>
 *     <cxn ang="3cd4">
 *       <pos x="il" y="it" />
 *     </cxn>
 *     <cxn ang="cd2">
 *       <pos x="l" y="vc" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="il" y="ib" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="hc" y="b" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="ir" y="ib" />
 *     </cxn>
 *     <cxn ang="0">
 *       <pos x="r" y="vc" />
 *     </cxn>
 *     <cxn ang="3cd4">
 *       <pos x="ir" y="it" />
 *     </cxn>
 *   </cxnLst>
 *   <rect l="il" t="it" r="ir" b="ib" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <path>
 *       <moveTo>
 *         <pt x="l" y="vc" />
 *       </moveTo>
 *       <arcTo wR="wd2" hR="hd2" stAng="cd2" swAng="cd4" />
 *       <arcTo wR="wd2" hR="hd2" stAng="3cd4" swAng="cd4" />
 *       <arcTo wR="wd2" hR="hd2" stAng="0" swAng="cd4" />
 *       <arcTo wR="wd2" hR="hd2" stAng="cd4" swAng="cd4" />
 *       <close />
 *     </path>
 *   </pathLst>
 * </ellipse>
 */
